<div class="details-panel-overlay" [class.visible]="visible">
  <div class="details-toolbar">
    <ng-content select="[toolbarStart]"></ng-content>
    <span>{{ title }}</span>
    <app-gpd-button
      *ngIf="showEditButton"
      type="text"
      icon="edit"
      (onClick)="onEdit.emit()"
    ></app-gpd-button>
    <app-gpd-button
      type="text"
      icon="cancel"
      (onClick)="onClose.emit()"
    ></app-gpd-button>
  </div>
  <div class="details-panel">
    <ng-content></ng-content>
  </div>
</div>
